import React, { useEffect, useState } from "react";
import axios from "axios";
import { getApiUrl, getMediaUrl } from "../utils/site";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(getApiUrl("/api/gallery"))
      .then((res) => setImages(Array.isArray(res.data) ? res.data : []))
      .catch((error) => {
        console.error("Error loading gallery:", error);
        setImages([]);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="roha-empty-state">Loading AI gallery...</div>;
  }

  if (!images.length) {
    return <div className="roha-empty-state">No AI gallery images are available yet.</div>;
  }

  return (
    <div className="roha-gallery-grid">
      {images.map((img) => (
        <article key={img.id} className="roha-gallery-card">
          <img
            src={getMediaUrl(img.image_url)}
            alt={img.prompt || "AI jewellery concept"}
            loading="lazy"
          />
          <div className="roha-gallery-card__body">
            <strong>{img.prompt || "AI gemstone concept"}</strong>
            <p>
              {img.created_at
                ? new Date(img.created_at).toLocaleString()
                : "Generated jewellery inspiration"}
            </p>
          </div>
        </article>
      ))}
    </div>
  );
}
